import React from 'react';
import { Icon } from 'semantic-ui-react';

import { Subtitle } from '../styles';

const RejectedView: React.FC = () => (
  <>
    <Subtitle style={{ marginBottom: 16 }}>
      Não foi possível validar sua identidade na Pagar.me.
    </Subtitle>
    <p style={{ margin: '0 0 12px', color: '#4f5661', lineHeight: 1.5 }}>
      Este link de biometria não está mais disponível. Retorne à plataforma LadoBom
      e use a opção <strong>Tentar biometria novamente</strong> para iniciar um novo
      cadastro.
    </p>
    <p style={{ margin: 0, color: '#767676', fontSize: 14 }}>
      <Icon name="info circle" />
      Se você é colaborador, entre em contato com a imobiliária responsável.
    </p>
  </>
);

export default RejectedView;
